import { render, staticRenderFns } from "./preregistrov2.vue?vue&type=template&id=73839fc6&scoped=true&"
import script from "./preregistrov2.vue?vue&type=script&lang=js&"
export * from "./preregistrov2.vue?vue&type=script&lang=js&"
import style0 from "./preregistrov2.vue?vue&type=style&index=0&id=73839fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73839fc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLabel } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VContainer,VDialog,VDivider,VFlex,VForm,VImg,VLabel,VLayout,VRadio,VRadioGroup,VSlider,VSpacer,VTextField,VToolbar,VToolbarTitle})
